import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {ActivityPageRequest, ActivityResponse, Project} from '../../../../../core/models';
import {ProjectService} from '../../../../../core/services';
import {TokenService} from '../../../../../core/auth';

import {BreadcrumbService} from '../../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../../projectsidebar.service';

import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {Match, MatchEntry} from '../../../../../core/models/match';

@Component({
  selector: 'app-project-match',
  templateUrl: './project-match.page.html'
})
export class ProjectMatchPage implements OnInit {

  authUser = this.token.whoAmI();
  loading = false;

  project: Project;
  match: Match;
  matchEntries: MatchEntry[];
  matchEntriesSearchTerms: string;

  @Input() activityQuery = new ActivityPageRequest();
  activityResponse = new ActivityResponse();

  constructor(
    private route: ActivatedRoute,
    private token: TokenService,
    private projectService: ProjectService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService
  ) {
  }

  /**
   * Resolve route params.
   */
  ngOnInit() {
    combineLatest(this.route.parent.params, this.route.params)
      .pipe(map(results => ({projectId: results[0].id, matchId: results[1].matchId})))
      .subscribe(result => {
        this.init(result.projectId, result.matchId, this.match);
      });
  }

  /**
   * Load match, project and detections
   */
  init(projectId: string, matchId: string, match: Match) {
    this.loading = true;

    const subs = [];
    subs.push(this.projectService.getMatchByExternalId(projectId, matchId));
    subs.push(this.projectService.getOne(projectId));

    forkJoin(subs).subscribe(
      (results) => {
        this.match = <Match>results[0];
        this.matchEntries = this.match.gameMatchEntries;
        this.project = results[1];

        this.activityQuery.projectId = this.project.id;
        this.loadActivities();

        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {label: 'activity/match', routerLink: ['/project', this.project.id, 'activity', 'match']},
          {label: this.match.matchId}
        ]);

        this.loading = false;
      },
      (error) => {
        this.loading = false;
      });
  }

  loadActivities() {
    this.projectService.getMatchActivities(this.project.id, this.match.matchId, this.activityQuery).subscribe(
      (data) => {
        this.activityResponse = data;
      }
    );
  }

  paginateActivities(event) {
    delete (this.activityQuery.projectId);
    this.activityQuery.page = (event.first / event.rows) + 1;
    this.activityQuery.sortField = event.sortField !== undefined ? event.sortField : 'creationDate';
    this.activityQuery.sortDir = 'desc';
    this.loadActivities();
  }

  searchActivities(query: ActivityPageRequest): void {
    this.activityQuery = query;
    this.loadActivities();
  }

  searchMatchEntries(matchEntriesSearchTerms: string) {
    this.matchEntries = this.match.gameMatchEntries.filter((gme) => {
      return gme.session.player.platformClientId.toLowerCase().includes(matchEntriesSearchTerms.toLowerCase());
    });
  }

}
